import { useState } from 'react';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { ChevronDown } from 'lucide-react';

interface PlatformDisclaimerCheckboxProps {
  accepted: boolean;
  onAcceptedChange: (accepted: boolean) => void;
}

const PlatformDisclaimerCheckbox = ({ accepted, onAcceptedChange }: PlatformDisclaimerCheckboxProps) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="space-y-2 rounded-lg border border-gray-700 bg-gray-900/50 p-4">
      <Collapsible open={expanded} onOpenChange={setExpanded}>
        <CollapsibleTrigger className="flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors w-full text-left">
          <ChevronDown className={`h-4 w-4 transition-transform ${expanded ? 'rotate-180' : ''}`} />
          <span className="font-medium">Platform Responsibility Disclaimer</span>
        </CollapsibleTrigger>
        <CollapsibleContent className="mt-3 space-y-3 text-xs text-gray-400 pl-6">
          <p>
            Players Lockeroom is a technology platform that provides visibility, networking, and
            promotional tools for sports participants, teams, and organizations.
          </p>
          <p>
            Players Lockeroom does not create, manage, or enforce team, league, or event policies,
            including but not limited to participation eligibility, roster decisions, or division
            classifications.
          </p>
          <p>
            All decisions regarding participation, team placement, and eligibility are made solely by
            the respective teams, leagues, or event organizers.
          </p>
          <p>
            By using this platform, you acknowledge that Players Lockeroom is not responsible for,
            and does not control, the policies, decisions, or actions of any third-party users, teams,
            or organizations.
          </p>
        </CollapsibleContent>
      </Collapsible>

      <div className="flex items-start gap-3 pt-2">
        <Checkbox
          id="platform-disclaimer"
          checked={accepted}
          onCheckedChange={(checked) => onAcceptedChange(checked === true)}
          className="mt-0.5 border-gray-600 data-[state=checked]:bg-sports-green data-[state=checked]:border-sports-green"
        />
        <Label
          htmlFor="platform-disclaimer"
          className="text-xs text-gray-300 cursor-pointer leading-relaxed"
        >
          I acknowledge and agree to the Platform Responsibility Disclaimer. I understand that Players
          Lockeroom is a technology platform and does not control third-party policies or decisions.
        </Label>
      </div>
    </div>
  );
};

export default PlatformDisclaimerCheckbox;
